module.exports = __webpack_public_path__ + "static/media/6.14362e8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instructorsPhoto/6.jpg
// module id = 247
// module chunks = 1